// src/components/About.js
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import topbatch from "../../images/topbatch.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useDispatch, useSelector } from "react-redux";
import { fetchAds } from "../../redux/adSlice";
import { fetchTopProjects } from "../../redux/homeSlice";
import { fetchPopularLocalities } from "../../redux/popularLocalitySlice";
import dummyImg from "../../images/no-image-thumb.jpg";
import generateSlug from "./generateSlug";
import UrltoSlug from "./UrlToSlug";

const AdvProject = ({
  param = { id: 1, name: "Jaipur" },
  prefix = "srcid",
  service,
}) => {
  const dispatch = useDispatch();
  // const { ads, status: adsStatus, error: adsError } = useSelector((state) => state.ads);
  const {
    topProjects,
    status: homeStatus,
    error: homeError,
  } = useSelector((state) => state.home);
  const {
    popularLocalities,
    status: localityStatus,
    error: localityError,
  } = useSelector((state) => state.popularLocalities);

  const handleLinkClick = (project) => {
    const text1 = `/buy/searches`;
    const text2 = `${project?.property_location}-srlid-${project?.id}`;
    const extra = "apartments-for-sale-in-";
    const url = `${text1}/${extra ?? "property-in-"}${UrltoSlug(text2)}`;
    localStorage.setItem("feature_clicked", `property_type:apartment`);
    window.location.href = url;
  };

  const handleProjectLinkClick = (project) => {
    const url = generateSlug(project);
    window.location.href = url;
  };

  useEffect(() => {
    const carousel = document.querySelector("#gitSampleCarousel");
    if (carousel && window.bootstrap?.Carousel) {
      new window.bootstrap.Carousel(carousel, { interval: 2000 });
    }
  }, []);

  useEffect(() => {
    if (param?.id) {
      dispatch(fetchAds(param?.id));
      dispatch(fetchTopProjects());
      dispatch(fetchPopularLocalities());
    }
  }, []);

  return (
    <>
      {topProjects?.length > 0 && (
        <div
          id="gitSampleCarousel"
          className="carousel slide mob"
          data-bs-ride="carousel"
        >
          {topProjects?.length > 0 && (
            <img src={topbatch} className="mobtopbatch" alt="Top Batch" />
          )}

          <div className="carousel-inner">
            {topProjects?.length > 0 &&
              topProjects
                .filter((project) =>
                  prefix === "srcid"
                    ? project.city_name === param?.name
                    : project.sub_locality_name === param?.name
                )
                .map((project, index) => (
                  <div
                    key={index}
                    className={`carousel-item ${
                      index === 0 ? "active" : ""
                    } custom-slide`}
                  >
                    <Link onClick={() => handleProjectLinkClick(project)}>
                      <img
                        src={project.property_image[0]?.image}
                        className="img-fluid"
                        alt={project.project_name}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = dummyImg;
                        }}
                      />
                      <div className="custom-overlay">
                        <h3 className="ad-slider-text">
                          {project.project_name}
                        </h3>
                        <p className="avd-title-text-2">
                          {project.sub_locality_name}
                        </p>
                      </div>
                    </Link>
                  </div>
                ))}
          </div>

          {topProjects?.length > 0 && (
            <>
              <button
                className="custom-btn custom-btn-prev"
                type="button"
                data-bs-target="#gitSampleCarousel"
                data-bs-slide="prev"
              >
                <span>&lt;</span>
              </button>

              <button
                className="custom-btn custom-btn-next"
                type="button"
                data-bs-target="#gitSampleCarousel"
                data-bs-slide="next"
              >
                <span>&gt;</span>
              </button>
            </>
          )}
        </div>
      )}

      {popularLocalities?.length > 0 && (
        <div
          id="gitSampleCarousel1"
          className="mob carousel slide popular_locality"
          data-bs-ride="carousel"
        >
          <p>Popular Locality for sale</p>
          <div className="titleunderline">
            <svg
              width="71"
              height="7"
              viewBox="0 0 71 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.113249 3.5L3 6.38675L5.88675 3.5L3 0.613249L0.113249 3.5ZM70.8867 3.5L68 0.613249L65.1132 3.5L68 6.38675L70.8867 3.5ZM3 4H68V3H3V4Z"
                fill="#002842"
              />
              <line
                x1="8.5"
                y1="6.5"
                x2="62.5"
                y2="6.5"
                stroke="#002842"
                strokeLinecap="round"
              />
            </svg>
          </div>

          <div className="carousel-inner custom-slider">
            {popularLocalities?.length > 0 &&
              popularLocalities
                .reduce((result, project, index) => {
                  if (index % 2 === 0) result.push([]);
                  result[result.length - 1].push(project);
                  return result;
                }, [])
                .map((group, i) => (
                  <div
                    className={`carousel-item ${
                      i === 0 ? "active" : ""
                    } custom-slide`}
                    key={i}
                  >
                    <div className="row">
                      {group.map((project, index) => (
                        <div className="col-md-6 col-6 mb-4" key={index}>
                          <div className="unique-card">
                            <h5 className="line-clamp1">
                              {project?.name || "N/A"}
                            </h5>
                            <div className="pricing_det">
                              <p className="price">
                                ₹ {parseInt(project?.avg_price) || 0}
                              </p>
                              <p className="details">Avg. Price Per Sq.Ft</p>
                            </div>
                            <div className="price_grap">
                              <p className="price">
                                {project?.price_increased ?? 0}%
                                {project?.price_increased >= 0 ? " ▲" : " ▼"}
                              </p>
                              <p className="details">Rise In Last 1 Year</p>
                            </div>
                            <Link onClick={() => handleLinkClick(project)}>
                              <button className="btn view-projects-btn">
                                View Projects
                              </button>
                            </Link>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
          </div>

          <button
            className="custom-btn custom-btn-prev"
            type="button"
            data-bs-target="#gitSampleCarousel1"
            data-bs-slide="prev"
          >
            <span>&lt;</span>
          </button>

          <button
            className="custom-btn custom-btn-next"
            type="button"
            data-bs-target="#gitSampleCarousel1"
            data-bs-slide="next"
          >
            <span>&gt;</span>
          </button>
        </div>
      )}
    </>
  );
};

export default AdvProject;
